(ns frontend.view.reports.custom.alj-2.deals-presented-to-CIC-this-year-pie-chart
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [reagent.core :as r]
   [frontend.state.current-session :as session]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]

   [common.dates :as dates]))

(defn deal-cic-approval-group
  [oppo]
  (let [approval-status-id (:oppo/CIC-recommendation oppo)
        approval-entity (get @session/entities approval-status-id)
        nv (:named-value/value approval-entity)]
    (case nv
      "Approved" "Approved"
      "Declined" "Declined"
      "Deferred" "Deferred"
      "Other")))

(defn pie-deals-presented-to-CIC-chart-data
  [deals]
  (let [CIC-recommendation-frequencies (->> deals
                                            (filter :oppo/CIC-recommendation)
                                            (group-by deal-cic-approval-group)
                                            (map (fn [[recommendation deals]]
                                                   [recommendation (count deals)]))
                                            (sort-by second)
                                            (reverse))]
    {:series [{:name         (loc/tr :oppo/CIC-recommendation)
               :colorByPoint true
               :data         (->> CIC-recommendation-frequencies
                                  (map (fn [[label deal-count]]
                                         {:name label
                                          :y    deal-count}))
                                  (vec))}]}))

(defn cic-presented
  []
  (let [now (dates/date)]
    (->> (alj/all-deals)
         (filter (fn [oppo]
                   (:oppo/date-CIC-presentation oppo)))
         (doall))))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-cic #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/remove-by :oppo/status :oppo.status/on-hold)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/date-CIC-presentation @date-state-atom :date-cic :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))
            ;presented-deals (->> (cic-presented) (alj-utils/deals-in-date-range :oppo/date-CIC-presentation date-state-atom))
            chart-data (pie-deals-presented-to-CIC-chart-data deals)
            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [label y]}]
                                    [label y]))
                             (doall))
            view-name "Total deals presented to IAC"]
        [alj-components/alj-pie-chart
         {:view-name       view-name
          :total-deals     (count deals)
          :total-amount    (alj-utils/ticket-size-sum-billions deals)
          :report-data     export-data
          :chart-data      chart-data
          :date-state-atom date-state-atom}]))))
